import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import type { Pph23RefundRecordInterface } from 'features/AdsManagement/pages/AdsPph23Refund/types'

export const SLICE_NAME = 'adsPph23Refund'

export type ListFetchStatusType = 'idle' | 'loading' | 'success' | 'error'

type PaginationStateType = {
  next_cursor: string
  prev_cursor: string
}

interface AdsPph23RefundStateInterface {
  isLoading: boolean
  isSubmitting: boolean
  isExporting: boolean
  submissions: Pph23RefundRecordInterface[]
  pagination: PaginationStateType
  listFetchStatus: ListFetchStatusType
}

const initialState: AdsPph23RefundStateInterface = {
  isLoading: false,
  isSubmitting: false,
  isExporting: false,
  submissions: [],
  pagination: { next_cursor: '', prev_cursor: '' },
  listFetchStatus: 'idle',
}

const adsPph23RefundSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setIsSubmitting: (state, action: PayloadAction<boolean>) => {
      state.isSubmitting = action.payload
    },
    setIsExporting: (state, action: PayloadAction<boolean>) => {
      state.isExporting = action.payload
    },
    setSubmissions: (state, action: PayloadAction<Pph23RefundRecordInterface[]>) => {
      state.submissions = action.payload
    },
    setPagination: (state, action: PayloadAction<PaginationStateType>) => {
      state.pagination = action.payload
    },
    setListFetchStatus: (state, action: PayloadAction<ListFetchStatusType>) => {
      state.listFetchStatus = action.payload
    },
  },
})

export const {
  setIsLoading,
  setIsSubmitting,
  setIsExporting,
  setSubmissions,
  setPagination,
  setListFetchStatus,
} = adsPph23RefundSlice.actions

export default adsPph23RefundSlice.reducer
